import React, { ComponentType, ReactNodeArray } from 'react';
import { RouteProps } from 'react-router-dom';

export interface IRoute extends RouteProps {
  permission?: string | string[];
  container?: boolean;
}

export interface IRoutes<T> {
  [name: string]: T;
}

const RouteGenerator = <T extends IRoute = IRoute>(
  routes: IRoutes<T> | { key: string; route: T }[],
  RouteComponent: ComponentType<T>
): ReactNodeArray => {
  if (Array.isArray(routes)) {
    return routes.map(({ key, route }) => <RouteComponent key={key} {...route} />);
  }
  return Object.keys(routes).map((key: string) => <RouteComponent key={key} {...routes[key]} />);
};

export default RouteGenerator;
